import * as API from "middleware/api";

const FILTER_TO_ACTIVITY = {
    COMPRA: "currencyExchange.confirm.buy",
    VENTA: "currencyExchange.confirm.sell",
};

export const getQuote = () => API.executeWithAccessToken("/currencyExchange.quote", {});

export const getHistory = (filterType, pageNumber) =>
    API.executeWithAccessToken("/transactions.list", {
        idActivity: FILTER_TO_ACTIVITY[filterType] || undefined,
        pageNumber: pageNumber || 1,
        onlyPendings: false,
        onlyTransfers: false,
        onlyCurrencyExchange: true,
        pendingDispatch: false,
        filterPendingDispatch: false,
    });

export const readTransaction = (transactionId) =>
    API.executeWithAccessToken("/core.readTransaction", {
        idTransactionToRead: transactionId,
    });

export const createRequest = (data) => API.executeWithAccessToken("/currencyExchange.preview", data);

/** Incluye tipoCuentaDebito / tipoCuentaCredito (CC|CA) para monitoreo /dolares cuando el flag de fraude está ON. */
export const confirmBuyRequest = (data) => {
    const { otp, ...rest } = data;
    return API.executeWithAccessToken("/currencyExchange.confirm.buy", { ...rest, _otp: otp });
};

/** Incluye tipoCuentaDebito / tipoCuentaCredito (CC|CA) para monitoreo /dolares cuando el flag de fraude está ON. */
export const confirmSellRequest = (data) => {
    const { otp, ...rest } = data;
    return API.executeWithAccessToken("/currencyExchange.confirm.sell", { ...rest, _otp: otp });
};
